// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/inventory_tag.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Base, ID } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/inventory_tag.proto.
 */
export const file_inventory_v1_inventory_tag: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types]);

/**
 * InventoryTag message definition
 *
 * @generated from message inventory.v1.InventoryTag
 */
export type InventoryTag = Message<"inventory.v1.InventoryTag"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: string tag_number = 2;
   */
  tagNumber: string;

  /**
   * @generated from field: inventory.v1.TagType tag_type = 3;
   */
  tagType: TagType;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 4;
   */
  generatedAt?: Timestamp;

  /**
   * @generated from field: inventory.v1.InventoryTagStatus status = 5;
   */
  status: InventoryTagStatus;

  /**
   * @generated from field: string gross_quantity = 6;
   */
  grossQuantity: string;

  /**
   * @generated from field: string tare = 7;
   */
  tare: string;

  /**
   * @generated from field: types.ID item_id = 8;
   */
  itemId?: ID;

  /**
   * @generated from field: types.ID facility_id = 9;
   */
  facilityId?: ID;

  /**
   * @generated from field: bool is_revised = 10;
   */
  isRevised: boolean;

  /**
   * @generated from field: inventory.v1.QuantityCaptureMethod quantity_capture_method = 11;
   */
  quantityCaptureMethod: QuantityCaptureMethod;

  /**
   * @generated from field: inventory.v1.QuantityCaptureMethod tare_capture_method = 12;
   */
  tareCaptureMethod: QuantityCaptureMethod;

  /**
   * @generated from field: types.ID lot_id = 13;
   */
  lotId?: ID;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 14;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: types.Base base = 15;
   */
  base?: Base;
};

/**
 * Describes the message inventory.v1.InventoryTag.
 * Use `create(InventoryTagSchema)` to create a new message.
 */
export const InventoryTagSchema: GenMessage<InventoryTag> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 0);

/**
 * TagQuantitySummary - custom type
 *
 * @generated from message inventory.v1.TagQuantitySummary
 */
export type TagQuantitySummary = Message<"inventory.v1.TagQuantitySummary"> & {
  /**
   * @generated from field: string tag_id = 1;
   */
  tagId: string;

  /**
   * @generated from field: string in_quantity = 2;
   */
  inQuantity: string;

  /**
   * @generated from field: string out_quantity = 3;
   */
  outQuantity: string;

  /**
   * @generated from field: string net_quantity = 4;
   */
  netQuantity: string;
};

/**
 * Describes the message inventory.v1.TagQuantitySummary.
 * Use `create(TagQuantitySummarySchema)` to create a new message.
 */
export const TagQuantitySummarySchema: GenMessage<TagQuantitySummary> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 1);

/**
 * InventoryTagAllocateResult - custom type
 *
 * @generated from message inventory.v1.InventoryTagAllocateResult
 */
export type InventoryTagAllocateResult = Message<"inventory.v1.InventoryTagAllocateResult"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag tag = 1;
   */
  tag?: InventoryTag;

  /**
   * @generated from field: repeated string allocations = 2;
   */
  allocations: string[];
};

/**
 * Describes the message inventory.v1.InventoryTagAllocateResult.
 * Use `create(InventoryTagAllocateResultSchema)` to create a new message.
 */
export const InventoryTagAllocateResultSchema: GenMessage<InventoryTagAllocateResult> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 2);

/**
 * TagReconciliationReport - custom type
 *
 * @generated from message inventory.v1.TagReconciliationReport
 */
export type TagReconciliationReport = Message<"inventory.v1.TagReconciliationReport"> & {
  /**
   * @generated from field: int32 total_tags = 1;
   */
  totalTags: number;

  /**
   * @generated from field: int32 tags_with_movements = 2;
   */
  tagsWithMovements: number;

  /**
   * @generated from field: int32 tags_without_movements = 3;
   */
  tagsWithoutMovements: number;

  /**
   * @generated from field: int32 quantity_mismatch_count = 4;
   */
  quantityMismatchCount: number;
};

/**
 * Describes the message inventory.v1.TagReconciliationReport.
 * Use `create(TagReconciliationReportSchema)` to create a new message.
 */
export const TagReconciliationReportSchema: GenMessage<TagReconciliationReport> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 3);

/**
 * BatchCreateInventoryTagInput - custom input type
 *
 * @generated from message inventory.v1.BatchCreateInventoryTagInput
 */
export type BatchCreateInventoryTagInput = Message<"inventory.v1.BatchCreateInventoryTagInput"> & {
  /**
   * @generated from field: string tag_number = 1;
   */
  tagNumber: string;

  /**
   * @generated from field: string tag_type = 2;
   */
  tagType: string;

  /**
   * @generated from field: string generated_at = 3;
   */
  generatedAt: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string gross_quantity = 5;
   */
  grossQuantity: string;

  /**
   * @generated from field: string tare = 6;
   */
  tare: string;

  /**
   * @generated from field: string item_id = 7;
   */
  itemId: string;

  /**
   * @generated from field: string facility_id = 8;
   */
  facilityId: string;

  /**
   * @generated from field: bool is_revised = 9;
   */
  isRevised: boolean;

  /**
   * @generated from field: string quantity_capture_method = 10;
   */
  quantityCaptureMethod: string;

  /**
   * @generated from field: string tare_capture_method = 11;
   */
  tareCaptureMethod: string;

  /**
   * @generated from field: string lot_id = 12;
   */
  lotId: string;

  /**
   * @generated from field: string custom_attributes = 13;
   */
  customAttributes: string;
};

/**
 * Describes the message inventory.v1.BatchCreateInventoryTagInput.
 * Use `create(BatchCreateInventoryTagInputSchema)` to create a new message.
 */
export const BatchCreateInventoryTagInputSchema: GenMessage<BatchCreateInventoryTagInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 4);

/**
 * Request/Response messages for InventoryTag queries
 *
 * @generated from message inventory.v1.GetInventoryTagRequest
 */
export type GetInventoryTagRequest = Message<"inventory.v1.GetInventoryTagRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetInventoryTagRequest.
 * Use `create(GetInventoryTagRequestSchema)` to create a new message.
 */
export const GetInventoryTagRequestSchema: GenMessage<GetInventoryTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 5);

/**
 * @generated from message inventory.v1.GetInventoryTagResponse
 */
export type GetInventoryTagResponse = Message<"inventory.v1.GetInventoryTagResponse"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag inventory_tag = 1;
   */
  inventoryTag?: InventoryTag;
};

/**
 * Describes the message inventory.v1.GetInventoryTagResponse.
 * Use `create(GetInventoryTagResponseSchema)` to create a new message.
 */
export const GetInventoryTagResponseSchema: GenMessage<GetInventoryTagResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 6);

/**
 * @generated from message inventory.v1.ListInventoryTagsRequest
 */
export type ListInventoryTagsRequest = Message<"inventory.v1.ListInventoryTagsRequest"> & {
  /**
   * @generated from field: inventory.v1.ListInventoryTagsFilter filter = 1;
   */
  filter?: ListInventoryTagsFilter;

  /**
   * @generated from field: repeated inventory.v1.InventoryTagSortOption sorting = 2;
   */
  sorting: InventoryTagSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message inventory.v1.ListInventoryTagsRequest.
 * Use `create(ListInventoryTagsRequestSchema)` to create a new message.
 */
export const ListInventoryTagsRequestSchema: GenMessage<ListInventoryTagsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 7);

/**
 * @generated from message inventory.v1.ListInventoryTagsFilter
 */
export type ListInventoryTagsFilter = Message<"inventory.v1.ListInventoryTagsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: google.protobuf.StringValue search_term = 3;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 4;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.ListInventoryTagsFilter.
 * Use `create(ListInventoryTagsFilterSchema)` to create a new message.
 */
export const ListInventoryTagsFilterSchema: GenMessage<ListInventoryTagsFilter> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 8);

/**
 * @generated from message inventory.v1.ListInventoryTagsResponse
 */
export type ListInventoryTagsResponse = Message<"inventory.v1.ListInventoryTagsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.InventoryTag inventory_tags = 1;
   */
  inventoryTags: InventoryTag[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message inventory.v1.ListInventoryTagsResponse.
 * Use `create(ListInventoryTagsResponseSchema)` to create a new message.
 */
export const ListInventoryTagsResponseSchema: GenMessage<ListInventoryTagsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 9);

/**
 * Command messages
 *
 * @generated from message inventory.v1.CreateInventoryTagRequest
 */
export type CreateInventoryTagRequest = Message<"inventory.v1.CreateInventoryTagRequest"> & {
  /**
   * @generated from field: inventory.v1.InventoryTagInput input = 1;
   */
  input?: InventoryTagInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.CreateInventoryTagRequest.
 * Use `create(CreateInventoryTagRequestSchema)` to create a new message.
 */
export const CreateInventoryTagRequestSchema: GenMessage<CreateInventoryTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 10);

/**
 * @generated from message inventory.v1.CreateInventoryTagResponse
 */
export type CreateInventoryTagResponse = Message<"inventory.v1.CreateInventoryTagResponse"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag inventory_tag = 1;
   */
  inventoryTag?: InventoryTag;
};

/**
 * Describes the message inventory.v1.CreateInventoryTagResponse.
 * Use `create(CreateInventoryTagResponseSchema)` to create a new message.
 */
export const CreateInventoryTagResponseSchema: GenMessage<CreateInventoryTagResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 11);

/**
 * @generated from message inventory.v1.UpdateInventoryTagRequest
 */
export type UpdateInventoryTagRequest = Message<"inventory.v1.UpdateInventoryTagRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: inventory.v1.InventoryTagUpdateInput input = 2;
   */
  input?: InventoryTagUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.UpdateInventoryTagRequest.
 * Use `create(UpdateInventoryTagRequestSchema)` to create a new message.
 */
export const UpdateInventoryTagRequestSchema: GenMessage<UpdateInventoryTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 12);

/**
 * @generated from message inventory.v1.UpdateInventoryTagResponse
 */
export type UpdateInventoryTagResponse = Message<"inventory.v1.UpdateInventoryTagResponse"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag inventory_tag = 1;
   */
  inventoryTag?: InventoryTag;
};

/**
 * Describes the message inventory.v1.UpdateInventoryTagResponse.
 * Use `create(UpdateInventoryTagResponseSchema)` to create a new message.
 */
export const UpdateInventoryTagResponseSchema: GenMessage<UpdateInventoryTagResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 13);

/**
 * @generated from message inventory.v1.DeleteInventoryTagRequest
 */
export type DeleteInventoryTagRequest = Message<"inventory.v1.DeleteInventoryTagRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.DeleteInventoryTagRequest.
 * Use `create(DeleteInventoryTagRequestSchema)` to create a new message.
 */
export const DeleteInventoryTagRequestSchema: GenMessage<DeleteInventoryTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 14);

/**
 * Input messages
 *
 * @generated from message inventory.v1.InventoryTagInput
 */
export type InventoryTagInput = Message<"inventory.v1.InventoryTagInput"> & {
  /**
   * @generated from field: string tag_number = 1;
   */
  tagNumber: string;

  /**
   * @generated from field: inventory.v1.TagType tag_type = 2;
   */
  tagType: TagType;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 3;
   */
  generatedAt?: Timestamp;

  /**
   * @generated from field: inventory.v1.InventoryTagStatus status = 4;
   */
  status: InventoryTagStatus;

  /**
   * @generated from field: string gross_quantity = 5;
   */
  grossQuantity: string;

  /**
   * @generated from field: string tare = 6;
   */
  tare: string;

  /**
   * @generated from field: types.ID item_id = 7;
   */
  itemId?: ID;

  /**
   * @generated from field: types.ID facility_id = 8;
   */
  facilityId?: ID;

  /**
   * @generated from field: bool is_revised = 9;
   */
  isRevised: boolean;

  /**
   * @generated from field: inventory.v1.QuantityCaptureMethod quantity_capture_method = 10;
   */
  quantityCaptureMethod: QuantityCaptureMethod;

  /**
   * @generated from field: inventory.v1.QuantityCaptureMethod tare_capture_method = 11;
   */
  tareCaptureMethod: QuantityCaptureMethod;

  /**
   * @generated from field: types.ID lot_id = 12;
   */
  lotId?: ID;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 13;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message inventory.v1.InventoryTagInput.
 * Use `create(InventoryTagInputSchema)` to create a new message.
 */
export const InventoryTagInputSchema: GenMessage<InventoryTagInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 15);

/**
 * @generated from message inventory.v1.InventoryTagUpdateInput
 */
export type InventoryTagUpdateInput = Message<"inventory.v1.InventoryTagUpdateInput"> & {
  /**
   * @generated from field: google.protobuf.StringValue tag_number = 1;
   */
  tagNumber?: string;

  /**
   * @generated from field: inventory.v1.TagType tag_type = 2;
   */
  tagType: TagType;

  /**
   * @generated from field: google.protobuf.Timestamp generated_at = 3;
   */
  generatedAt?: Timestamp;

  /**
   * @generated from field: inventory.v1.InventoryTagStatus status = 4;
   */
  status: InventoryTagStatus;

  /**
   * @generated from field: google.protobuf.StringValue gross_quantity = 5;
   */
  grossQuantity?: string;

  /**
   * @generated from field: google.protobuf.StringValue tare = 6;
   */
  tare?: string;

  /**
   * @generated from field: types.ID item_id = 7;
   */
  itemId?: ID;

  /**
   * @generated from field: types.ID facility_id = 8;
   */
  facilityId?: ID;

  /**
   * @generated from field: google.protobuf.BoolValue is_revised = 9;
   */
  isRevised?: boolean;

  /**
   * @generated from field: inventory.v1.QuantityCaptureMethod quantity_capture_method = 10;
   */
  quantityCaptureMethod: QuantityCaptureMethod;

  /**
   * @generated from field: inventory.v1.QuantityCaptureMethod tare_capture_method = 11;
   */
  tareCaptureMethod: QuantityCaptureMethod;

  /**
   * @generated from field: types.ID lot_id = 12;
   */
  lotId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 13;
   */
  customAttributes?: string;
};

/**
 * Describes the message inventory.v1.InventoryTagUpdateInput.
 * Use `create(InventoryTagUpdateInputSchema)` to create a new message.
 */
export const InventoryTagUpdateInputSchema: GenMessage<InventoryTagUpdateInput> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 16);

/**
 * GetInventoryTagByTagNumberRequest - custom query request
 *
 * @generated from message inventory.v1.GetInventoryTagByTagNumberRequest
 */
export type GetInventoryTagByTagNumberRequest = Message<"inventory.v1.GetInventoryTagByTagNumberRequest"> & {
  /**
   * @generated from field: string tag_number = 1;
   */
  tagNumber: string;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetInventoryTagByTagNumberRequest.
 * Use `create(GetInventoryTagByTagNumberRequestSchema)` to create a new message.
 */
export const GetInventoryTagByTagNumberRequestSchema: GenMessage<GetInventoryTagByTagNumberRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 17);

/**
 * GetInventoryTagByTagNumberResponse - custom query response
 *
 * @generated from message inventory.v1.GetInventoryTagByTagNumberResponse
 */
export type GetInventoryTagByTagNumberResponse = Message<"inventory.v1.GetInventoryTagByTagNumberResponse"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag result = 1;
   */
  result?: InventoryTag;
};

/**
 * Describes the message inventory.v1.GetInventoryTagByTagNumberResponse.
 * Use `create(GetInventoryTagByTagNumberResponseSchema)` to create a new message.
 */
export const GetInventoryTagByTagNumberResponseSchema: GenMessage<GetInventoryTagByTagNumberResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 18);

/**
 * GetInventoryTagsByCustomAttributeRequest - custom query request
 *
 * @generated from message inventory.v1.GetInventoryTagsByCustomAttributeRequest
 */
export type GetInventoryTagsByCustomAttributeRequest = Message<"inventory.v1.GetInventoryTagsByCustomAttributeRequest"> & {
  /**
   * @generated from field: string attribute_name = 1;
   */
  attributeName: string;

  /**
   * @generated from field: repeated string attribute_values = 2;
   */
  attributeValues: string[];

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.GetInventoryTagsByCustomAttributeRequest.
 * Use `create(GetInventoryTagsByCustomAttributeRequestSchema)` to create a new message.
 */
export const GetInventoryTagsByCustomAttributeRequestSchema: GenMessage<GetInventoryTagsByCustomAttributeRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 19);

/**
 * GetInventoryTagsByCustomAttributeResponse - custom query response
 *
 * @generated from message inventory.v1.GetInventoryTagsByCustomAttributeResponse
 */
export type GetInventoryTagsByCustomAttributeResponse = Message<"inventory.v1.GetInventoryTagsByCustomAttributeResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.InventoryTag result = 1;
   */
  result: InventoryTag[];
};

/**
 * Describes the message inventory.v1.GetInventoryTagsByCustomAttributeResponse.
 * Use `create(GetInventoryTagsByCustomAttributeResponseSchema)` to create a new message.
 */
export const GetInventoryTagsByCustomAttributeResponseSchema: GenMessage<GetInventoryTagsByCustomAttributeResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 20);

/**
 * CheckInventoryTagSearchPermissionsRequest - custom query request
 *
 * @generated from message inventory.v1.CheckInventoryTagSearchPermissionsRequest
 */
export type CheckInventoryTagSearchPermissionsRequest = Message<"inventory.v1.CheckInventoryTagSearchPermissionsRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.CheckInventoryTagSearchPermissionsRequest.
 * Use `create(CheckInventoryTagSearchPermissionsRequestSchema)` to create a new message.
 */
export const CheckInventoryTagSearchPermissionsRequestSchema: GenMessage<CheckInventoryTagSearchPermissionsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 21);

/**
 * CheckInventoryTagSearchPermissionsResponse - custom query response
 *
 * @generated from message inventory.v1.CheckInventoryTagSearchPermissionsResponse
 */
export type CheckInventoryTagSearchPermissionsResponse = Message<"inventory.v1.CheckInventoryTagSearchPermissionsResponse"> & {
  /**
   * @generated from field: repeated string permitted_ids = 1;
   */
  permittedIds: string[];
};

/**
 * Describes the message inventory.v1.CheckInventoryTagSearchPermissionsResponse.
 * Use `create(CheckInventoryTagSearchPermissionsResponseSchema)` to create a new message.
 */
export const CheckInventoryTagSearchPermissionsResponseSchema: GenMessage<CheckInventoryTagSearchPermissionsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 22);

/**
 * BatchUpdateStatusRequest - custom mutation request
 *
 * @generated from message inventory.v1.BatchUpdateStatusRequest
 */
export type BatchUpdateStatusRequest = Message<"inventory.v1.BatchUpdateStatusRequest"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.BatchUpdateStatusRequest.
 * Use `create(BatchUpdateStatusRequestSchema)` to create a new message.
 */
export const BatchUpdateStatusRequestSchema: GenMessage<BatchUpdateStatusRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 23);

/**
 * BatchUpdateStatusResponse - custom mutation response
 *
 * @generated from message inventory.v1.BatchUpdateStatusResponse
 */
export type BatchUpdateStatusResponse = Message<"inventory.v1.BatchUpdateStatusResponse"> & {
  /**
   * @generated from field: int32 result = 1;
   */
  result: number;
};

/**
 * Describes the message inventory.v1.BatchUpdateStatusResponse.
 * Use `create(BatchUpdateStatusResponseSchema)` to create a new message.
 */
export const BatchUpdateStatusResponseSchema: GenMessage<BatchUpdateStatusResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 24);

/**
 * BatchCreateInventoryTagRequest - custom mutation request
 *
 * @generated from message inventory.v1.BatchCreateInventoryTagRequest
 */
export type BatchCreateInventoryTagRequest = Message<"inventory.v1.BatchCreateInventoryTagRequest"> & {
  /**
   * @generated from field: repeated inventory.v1.BatchCreateInventoryTagInput inputs = 1;
   */
  inputs: BatchCreateInventoryTagInput[];

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message inventory.v1.BatchCreateInventoryTagRequest.
 * Use `create(BatchCreateInventoryTagRequestSchema)` to create a new message.
 */
export const BatchCreateInventoryTagRequestSchema: GenMessage<BatchCreateInventoryTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 25);

/**
 * BatchCreateInventoryTagResponse - custom mutation response
 *
 * @generated from message inventory.v1.BatchCreateInventoryTagResponse
 */
export type BatchCreateInventoryTagResponse = Message<"inventory.v1.BatchCreateInventoryTagResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.InventoryTag result = 1;
   */
  result: InventoryTag[];
};

/**
 * Describes the message inventory.v1.BatchCreateInventoryTagResponse.
 * Use `create(BatchCreateInventoryTagResponseSchema)` to create a new message.
 */
export const BatchCreateInventoryTagResponseSchema: GenMessage<BatchCreateInventoryTagResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag, 26);

/**
 * TagType enum
 *
 * @generated from enum inventory.v1.TagType
 */
export enum TagType {
  /**
   * @generated from enum value: TAG_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAG_TYPE_WORK_IN_PROGRESS = 1;
   */
  WORK_IN_PROGRESS = 1,

  /**
   * @generated from enum value: TAG_TYPE_FINISHED_GOOD = 2;
   */
  FINISHED_GOOD = 2,
}

/**
 * Describes the enum inventory.v1.TagType.
 */
export const TagTypeSchema: GenEnum<TagType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_inventory_tag, 0);

/**
 * InventoryTagStatus enum
 *
 * @generated from enum inventory.v1.InventoryTagStatus
 */
export enum InventoryTagStatus {
  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_REVISED = 2;
   */
  REVISED = 2,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_CONFIRMED = 4;
   */
  CONFIRMED = 4,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_DRAFT = 5;
   */
  DRAFT = 5,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_IN_INVENTORY = 6;
   */
  IN_INVENTORY = 6,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_IN_TRANSFER = 7;
   */
  IN_TRANSFER = 7,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_LOADED = 8;
   */
  LOADED = 8,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_PENDING_PURCHASE = 9;
   */
  PENDING_PURCHASE = 9,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_RESERVED = 10;
   */
  RESERVED = 10,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_SHIPPED = 11;
   */
  SHIPPED = 11,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_SOLD = 12;
   */
  SOLD = 12,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_TRANSFERRED = 13;
   */
  TRANSFERRED = 13,

  /**
   * @generated from enum value: INVENTORY_TAG_STATUS_VOIDED = 14;
   */
  VOIDED = 14,
}

/**
 * Describes the enum inventory.v1.InventoryTagStatus.
 */
export const InventoryTagStatusSchema: GenEnum<InventoryTagStatus> = /*@__PURE__*/
  enumDesc(file_inventory_v1_inventory_tag, 1);

/**
 * QuantityCaptureMethod enum
 *
 * @generated from enum inventory.v1.QuantityCaptureMethod
 */
export enum QuantityCaptureMethod {
  /**
   * @generated from enum value: QUANTITY_CAPTURE_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUANTITY_CAPTURE_METHOD_AUTOMATIC = 1;
   */
  AUTOMATIC = 1,

  /**
   * @generated from enum value: QUANTITY_CAPTURE_METHOD_MANUAL = 2;
   */
  MANUAL = 2,
}

/**
 * Describes the enum inventory.v1.QuantityCaptureMethod.
 */
export const QuantityCaptureMethodSchema: GenEnum<QuantityCaptureMethod> = /*@__PURE__*/
  enumDesc(file_inventory_v1_inventory_tag, 2);

/**
 * @generated from enum inventory.v1.InventoryTagSortOption
 */
export enum InventoryTagSortOption {
  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_TAG_NUMBER_ASC = 1;
   */
  TAG_NUMBER_ASC = 1,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_TAG_NUMBER_DESC = 2;
   */
  TAG_NUMBER_DESC = 2,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_GENERATED_AT_ASC = 3;
   */
  GENERATED_AT_ASC = 3,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_GENERATED_AT_DESC = 4;
   */
  GENERATED_AT_DESC = 4,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_CREATED_AT_ASC = 5;
   */
  CREATED_AT_ASC = 5,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_CREATED_AT_DESC = 6;
   */
  CREATED_AT_DESC = 6,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_UPDATED_AT_ASC = 7;
   */
  UPDATED_AT_ASC = 7,

  /**
   * @generated from enum value: INVENTORY_TAG_SORT_OPTION_UPDATED_AT_DESC = 8;
   */
  UPDATED_AT_DESC = 8,
}

/**
 * Describes the enum inventory.v1.InventoryTagSortOption.
 */
export const InventoryTagSortOptionSchema: GenEnum<InventoryTagSortOption> = /*@__PURE__*/
  enumDesc(file_inventory_v1_inventory_tag, 3);

/**
 * Services
 *
 * @generated from service inventory.v1.InventoryTagQueriesService
 */
export const InventoryTagQueriesService: GenService<{
  /**
   * @generated from rpc inventory.v1.InventoryTagQueriesService.GetInventoryTag
   */
  getInventoryTag: {
    methodKind: "unary";
    input: typeof GetInventoryTagRequestSchema;
    output: typeof GetInventoryTagResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagQueriesService.ListInventoryTags
   */
  listInventoryTags: {
    methodKind: "unary";
    input: typeof ListInventoryTagsRequestSchema;
    output: typeof ListInventoryTagsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagQueriesService.GetByTagNumber
   */
  getByTagNumber: {
    methodKind: "unary";
    input: typeof GetInventoryTagByTagNumberRequestSchema;
    output: typeof GetInventoryTagByTagNumberResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagQueriesService.GetByCustomAttribute
   */
  getByCustomAttribute: {
    methodKind: "unary";
    input: typeof GetInventoryTagsByCustomAttributeRequestSchema;
    output: typeof GetInventoryTagsByCustomAttributeResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagQueriesService.CheckSearchPermissions
   */
  checkSearchPermissions: {
    methodKind: "unary";
    input: typeof CheckInventoryTagSearchPermissionsRequestSchema;
    output: typeof CheckInventoryTagSearchPermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_inventory_tag, 0);

/**
 * @generated from service inventory.v1.InventoryTagCommandsService
 */
export const InventoryTagCommandsService: GenService<{
  /**
   * @generated from rpc inventory.v1.InventoryTagCommandsService.CreateInventoryTag
   */
  createInventoryTag: {
    methodKind: "unary";
    input: typeof CreateInventoryTagRequestSchema;
    output: typeof CreateInventoryTagResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagCommandsService.UpdateInventoryTag
   */
  updateInventoryTag: {
    methodKind: "unary";
    input: typeof UpdateInventoryTagRequestSchema;
    output: typeof UpdateInventoryTagResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagCommandsService.DeleteInventoryTag
   */
  deleteInventoryTag: {
    methodKind: "unary";
    input: typeof DeleteInventoryTagRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagCommandsService.BatchUpdateStatus
   */
  batchUpdateStatus: {
    methodKind: "unary";
    input: typeof BatchUpdateStatusRequestSchema;
    output: typeof BatchUpdateStatusResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.InventoryTagCommandsService.BatchCreateInventoryTag
   */
  batchCreateInventoryTag: {
    methodKind: "unary";
    input: typeof BatchCreateInventoryTagRequestSchema;
    output: typeof BatchCreateInventoryTagResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_inventory_tag, 1);

